/** @format */
import { createMachine } from 'xstate';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum CreateAlertMachineAction {
    SUBMIT = 'submit',
}

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum CreateAlertMachineState {
    FORM = 'form',
    CONFIRMATION = 'confirmation',
}

export const createAlertMachine = createMachine({
    predictableActionArguments: true,
    id: 'create-alert-machine',
    initial: CreateAlertMachineState.FORM,
    states: {
        [CreateAlertMachineState.FORM]: {
            on: {
                [CreateAlertMachineAction.SUBMIT]:
                    CreateAlertMachineState.CONFIRMATION,
            },
        },
        [CreateAlertMachineState.CONFIRMATION]: {},
    },
});
